<template>
    <zen-message-modal
        :isOpen="isOpen"
        @close="$emit('close')"
        title="Delivery log"
        iconVariant="sky"
        extraWide
    >
        <template #icon>
            <zen-icon-history />
        </template>
        <template #body>
            <p class="text-sm text-taupe-500 mb-4 truncate">
                {{ webhook?.url }}
            </p>
            <div v-if="loading" class="text-sm text-taupe-500 py-4">
                Loading deliveries…
            </div>
            <div
                v-else-if="items.length === 0"
                class="rounded-lg border border-dashed border-taupe-300 bg-taupe-50"
            >
                <zen-empty-table-message compact icon="ZenIconWebhook">
                    No deliveries recorded yet.
                </zen-empty-table-message>
            </div>
            <div v-else class="max-h-[60vh] overflow-y-auto">
                <table class="min-w-full divide-y divide-taupe-200 text-sm">
                    <thead class="sticky top-0 z-10 bg-white shadow-xs">
                        <tr>
                            <th
                                class="py-2 text-left text-xs font-medium text-taupe-500 uppercase tracking-wider"
                            >
                                Time
                            </th>
                            <th
                                class="py-2 text-left text-xs font-medium text-taupe-500 uppercase tracking-wider"
                            >
                                Action
                            </th>
                            <th
                                class="py-2 text-left text-xs font-medium text-taupe-500 uppercase tracking-wider"
                            >
                                Source
                            </th>
                            <th
                                class="py-2 text-left text-xs font-medium text-taupe-500 uppercase tracking-wider"
                            >
                                Status
                            </th>
                            <th
                                class="py-2 text-left text-xs font-medium text-taupe-500 uppercase tracking-wider"
                            >
                                Attempts
                            </th>
                            <th
                                class="py-2 text-left text-xs font-medium text-taupe-500 uppercase tracking-wider"
                            >
                                Next retry
                            </th>
                        </tr>
                    </thead>
                    <tbody class="divide-y divide-taupe-100">
                        <tr
                            v-for="delivery in items"
                            :key="delivery.ulid"
                            class="hover:bg-taupe-50"
                        >
                            <td class="py-2 text-taupe-500 whitespace-nowrap">
                                {{ formatDateTime(delivery.created_at) }}
                            </td>
                            <td class="py-2 text-taupe-800">
                                <span
                                    class="inline-block rounded bg-taupe-100 px-1.5 py-0.5 text-xs mr-1 font-mono"
                                    >{{ delivery.action }}</span
                                >
                                <span
                                    v-if="delivery.subject_label"
                                    class="text-xs text-taupe-500"
                                    >{{ delivery.subject_label }}</span
                                >
                            </td>
                            <td class="py-2 text-taupe-500 text-xs">
                                {{ delivery.source ?? '—' }}
                            </td>
                            <td class="py-2">
                                <span
                                    :class="
                                        delivery.status === 'success'
                                            ? 'text-green-700 bg-green-50 ring-green-600/10'
                                            : delivery.status === 'pending'
                                              ? 'text-amber-700 bg-amber-50 ring-amber-600/10'
                                              : 'text-red-700 bg-red-50 ring-red-600/10'
                                    "
                                    class="inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium ring-1 ring-inset"
                                >
                                    {{
                                        delivery.response_status ??
                                        delivery.status
                                    }}
                                </span>
                            </td>
                            <td class="py-2 text-taupe-500">
                                {{ delivery.attempt_count }}
                            </td>
                            <td class="py-2 text-taupe-500 whitespace-nowrap">
                                {{
                                    delivery.next_attempt_at
                                        ? formatDateTime(
                                              delivery.next_attempt_at
                                          )
                                        : '—'
                                }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </template>
        <template #buttons>
            <zen-button @click="$emit('close')" variant="secondary">
                Close
            </zen-button>
        </template>
    </zen-message-modal>
</template>

<script>
export default {
    name: 'WebhookDeliveriesModal',
    props: {
        isOpen: {
            type: Boolean,
            required: true,
        },
        webhook: {
            type: Object,
            default: null,
        },
        loading: {
            type: Boolean,
            default: false,
        },
        items: {
            type: Array,
            required: true,
        },
        formatDateTime: {
            type: Function,
            required: true,
        },
    },
    emits: ['close'],
}
</script>
